

import Promotion from "@core/Promotion.js";
import {$date, $util} from "@util/util.js";

export default class Kill extends Promotion{
    constructor(){
        super();
        this._leftTime = "";
        this._desc = "";
        this._lastDesc = "";
        // this._currentTime = _engine._currentTime;
    }

    //距秒杀开始：startTime - current
    //距秒杀结束：endTime - current
    
    init(data){
        this._id = data.id;
        this._name = "秒杀";
        this._type = data.type;
        this._startTime = data.startTime;
        this._endTime = data.endTime;
        // this._reservationStartTime = data.reservationStartTime;
        // this._reservationEndTime = data.reservationEndTime;
        this._inBuyTime = data.inBuyTime;
        this._purchaseCeiling = data.purchaseCeiling;
        this._isOrdinaryPurchase = data.isOrdinaryPurchase;
        this._deadLine = data.deadLine;
        if(this._isOrdinaryPurchase){
            var _sTime = this._startTime;  
            //兼容Safari 日期格式 
            if ( typeof _sTime == "string"){
                _sTime = _sTime.replace(/-/g, "/"); 
            }
            _sTime = new Date(_sTime);            
            this._showDeadLineTime =  _sTime.setTime(_sTime.getTime()-this._deadLine*60*1000);
        }else{            
            var _sTime = this._startTime;  
            //兼容Safari 日期格式 
            if ( typeof _sTime == "string"){
                _sTime = _sTime.replace(/-/g, "/"); 
            }
            _sTime = new Date(_sTime);
            this._showDeadLineTime =  _sTime.setTime(_sTime.getTime()-24*60*60*1000);
        }

        this.tick();
    }

    getLeftInfo(){
        if($date.equalTime(this._currentTime, this._showDeadLineTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._startTime)){
            window.location.href = window.location.href;
        }
        if($date.equalTime(this._currentTime, this._endTime)){
            window.location.href = window.location.href;
        }
        let bl = $date.compareData(this._currentTime, this._startTime);
        if(bl){
            this._desc = '还剩';
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._endTime);
            this._lastDesc = "恢复原价";
        }else{      
            if($date.compareData(this._currentTime, this._showDeadLineTime)){
                this._desc = '距秒杀活动开始还有';
                this._leftTime = $util.countDown.doCountDown(this._currentTime, this._startTime);
                this._lastDesc = "";
            }
        }
        // this._currentTime = this._currentTime + 1000;
    }

    tick(){
        const nowDate = new Date();
        this._currentTime = nowDate.getTime()+_engine._timeDiff;
        this.getLeftInfo();
        window.setInterval(()=>{
            const nowDate = new Date();
            this._currentTime = nowDate.getTime()+_engine._timeDiff;
            this.getLeftInfo();
        },1000)
    }
}